import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";

export default function ReviewsAdmin() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [file, setFile] = useState(null);
  const [form, setForm] = useState({
    id: null,
    name: "",
    role: "",
    content: "",
    avatar_url: "",
    order_index: 0,
  });

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("temoignages")
      .select("*")
      .order("order_index", { ascending: true });

    if (error) console.error("Error fetching reviews:", error);
    else setReviews(data);
    setLoading(false);
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) setFile(e.target.files[0]);
  };

  const uploadAvatar = async () => {
    if (!file) return null;
    setUploading(true);
    const fileExt = file.name.split(".").pop();
    const fileName = `${Date.now()}.${fileExt}`;
    const filePath = `reviews/${fileName}`;

    const { error } = await supabase.storage
      .from("animalia")
      .upload(filePath, file, { upsert: true });

    setUploading(false);
    if (error) {
      console.error("Upload error:", error);
      return null;
    }

    const { data } = supabase.storage.from("animalia").getPublicUrl(filePath);
    return { url: data.publicUrl, path: filePath };
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);

    let avatar = form.avatar_url;
    let avatar_url = form.avatar_url;

    if (file) {
      const uploaded = await uploadAvatar();
      if (uploaded) {
        avatar = uploaded.url;
        avatar_url = uploaded.path;
      }
    }

    if (form.id) {
      // Update
      const { error } = await supabase
        .from("temoignages")
        .update({
          name: form.name,
          role: form.role,
          content: form.content,
          avatar_url: avatar,
          avatar_url,
          order_index: form.order_index,
        })
        .eq("id", form.id);

      if (error) console.error(error);
    } else {
      // Insert
      const { error } = await supabase.from("temoignages").insert([
        {
          name: form.name,
          role: form.role,
          content: form.content,
          avatar_url: avatar,
          avatar_url,
          order_index: form.order_index,
        },
      ]);
      if (error) console.error(error);
    }

    setForm({ id: null, name: "", role: "", content: "", avatar_url: "", avatar_url: "", order_index: 0 });
    setFile(null);
    setSaving(false);
    fetchReviews();
  };

  const handleEdit = (r) => {
    setForm({
      id: r.id,
      name: r.name,
      role: r.role,
      content: r.content,
      avatar_url: r.avatar_url,
      avatar_url: r.avatar_url,
      order_index: r.order_index,
    });
  };

  const handleDelete = async (r) => {
    if (r.avatar_url) {
      await supabase.storage.from("animalia").remove([r.avatar_url]);
    }
    const { error } = await supabase.from("temoignages").delete().eq("id", r.id);
    if (error) console.error(error);
    fetchReviews();
  };

  return (
    <div className="container py-2" style={{ maxWidth: 900, marginLeft: "80px" }}>
      <h2 className="mb-3">Gestion des Témoignages</h2>

      {/* Form */}
      <div className="card mb-3 shadow-sm" style={{ fontSize: "0.85rem" ,height:"500px",width:"800px",marginLeft:"80px"}}>
        <div className="card-body">
          <form onSubmit={handleSave}>
            <div className="row">
              <div className="col-md-4 text-center">
                <label className="form-label d-block mb-1">Avatar</label>
                <div style={{ width: 120, height: 120, margin: "0 auto 8px", borderRadius: 8, overflow: "hidden", border: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "center", background: "#fafafa" }}>
             {form.avatar_url || form.avatar_path ? (
  <img
    src={
      form.avatar_url
        ? form.avatar_url
        : `https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/${form.avatar_path}`
    }
    alt="avatar"
    style={{ width: "100%", height: "100%", objectFit: "cover" }}
  />
) : (
  <div style={{ color: "#999", fontSize: 12 }}>Aucun</div>
)}

                </div>
                <input type="file" accept="image/*" onChange={handleFileChange} />
                {uploading && <div className="text-muted small">Upload...</div>}
                {form.id && (
                  <button type="button" className="btn btn-outline-secondary btn-sm mt-1" onClick={() => setForm({ id: null, name: "", role: "", content: "", avatar_url: "", avatar_url: "", order_index: 0 })}>
                    Annuler
                  </button>
                )}
              </div>

              <div className="col-md-8">
                <div className="mb-2">
                  <label className="form-label">Nom</label>
                  <input className="form-control form-control-sm" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} required />
                </div>
                <div className="mb-2">
                  <label className="form-label">Rôle</label>
                  <input className="form-control form-control-sm" value={form.role} onChange={(e) => setForm((p) => ({ ...p, role: e.target.value }))} />
                </div>
                <div className="mb-2 mt-50">
                  <label className="form-label">Témoignage</label>
                  <textarea className="form-control form-control-sm" rows={3} value={form.content} onChange={(e) => setForm((p) => ({ ...p, content: e.target.value }))} required />
                </div>
                <div className="mb-2">
                  <label className="form-label">Ordre</label>
                  <input type="number" className="form-control form-control-sm" value={form.order_index} onChange={(e) => setForm((p) => ({ ...p, order_index: Number(e.target.value) }))} />
                </div>

                <div className="d-flex gap-1">
                  <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>
                    {saving ? "Enregistrement..." : form.id ? "Modifier" : "Ajouter"}
                  </button>
                  {form.id && (
                    <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDelete(form)}>
                      Supprimer
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* List / Cards */}
      <div className="row">
        {loading ? (
          <div className="col-12 small">Chargement...</div>
        ) : reviews.length === 0 ? (
          <div className="col-12 small">Aucun témoignage.</div>
        ) : (
          reviews.map((r) => (
            <div className="col-md-4" key={r.id}>
              <div className="card mb-2 h-100 shadow-sm" style={{ fontSize: "0.85rem" }}>
                <div className="card-body d-flex flex-column">
                  <div className="d-flex align-items-center mb-2">
                    <div style={{ width: 48, height: 48, borderRadius: 8, overflow: "hidden", marginRight: 8 }}>
                 {r.avatar_url ? (
  <img
    src={
      r.avatar_url.startsWith("http")
        ? r.avatar_url
        : `https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/${r.avatar_url}`
    }
    alt={r.name}
    style={{ width: "100%", height: "100%", objectFit: "cover" }}
  />
) : (
  <div style={{ width: "100%", height: "100%", background: "#f0f0f0" }} />
)}

                    </div>
                    <div>
                      <div style={{ fontWeight: 600 }}>{r.name}</div>
                      <div style={{ fontSize: 12, color: "#666" }}>{r.role}</div>
                    </div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ whiteSpace: "pre-wrap" }}>{r.content}</p>
                  </div>
                  <div className="d-flex gap-1 mt-2">
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => handleEdit(r)}>Modifier</button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(r)}>Supprimer</button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
